import { Translate } from '@dreryk/react-common';
import { Dropdown, MoreIconVertical } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { healthCareInstitutionTranslationKeys, practitionersTranslationKeys } from '../../../../translations';

type OptionsCellProps = {
   readonly openPractitionerUpdatePermissionsModal: VoidFunction;
};

export const OptionsCell = (props: OptionsCellProps): JSX.Element => {
   const creatingAppointmentsAvailable = protectFeature('creatingAppointments');

   return (
      <Dropdown testId={'options'} triggerIcon={<MoreIconVertical />} triggerIconSuffixHidden>
         <Dropdown.Item
            testId={'practitionerUpdatePermission'}
            disabled={!creatingAppointmentsAvailable}
            onClick={(hide) => {
               props.openPractitionerUpdatePermissionsModal();
               hide();
            }}
         >
            <Dropdown.Item.Tooltip
               testId={'practitionerUpdatePermission'}
               content={healthCareInstitutionTranslationKeys.accountPartiallyBlocked}
               disabled={creatingAppointmentsAvailable}
            >
               <Translate>{practitionersTranslationKeys.editPractitionerPermissions}</Translate>
            </Dropdown.Item.Tooltip>
         </Dropdown.Item>
      </Dropdown>
   );
};
